/* eslint-disable */

export const createBot = {
    FETCH_CREATE_BOT_REQUEST: 'FETCH_CREATE_BOT_REQUEST',
    FETCH_CREATE_BOT_SUCCESS: 'FETCH_CREATE_BOT_SUCCESS',
    FETCH_CREATE_BOT_FAILURE: 'FETCH_CREATE_BOT_FAILURE',
};
